import { render, staticRenderFns } from "./draftbox.vue?vue&type=template&id=0138a26f&"
import script from "./draftbox.vue?vue&type=script&lang=js&"
export * from "./draftbox.vue?vue&type=script&lang=js&"
import style0 from "./draftbox.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports